//NOTE:资源太简单 不走配置了
const PANEL_NAME = "prompt_share/img_shareprompt.png"

let QQLiveSharePanel = xClass("QQLiveSharePanel", BasePanel, 
        () => {
            let rootNode = cc.Sprite.create()
            /*let imageNode = null
            if (cc.spriteFrameCache.getSpriteFrame(PANEL_NAME)) {
                imageNode = cc.Sprite.createWithSpriteFrameName(PANEL_NAME)
            }else {
                imageNode = cc.Sprite.create()
                let iconName = getRealResourceName(PANEL_NAME)
                cc.loader.autoLoad(iconName, function () {
                    let texture = cc.textureCache.addImage(PANEL_NAME)
                    imageNode._renderCmd._setTexture(texture);
                    imageNode.initWithFile(iconName)
                })
            }
            imageNode.setName("icon")
            rootNode.addChild(imageNode)*/
            return rootNode
    })


/**
 * 预加载资源
 */
QQLiveSharePanel.preload = function () {
    return preloadWithLoadingPromise(["cocos/prompt_share.plist"], true);
}

QQLiveSharePanel.prototype.ctor =  function (onCloseCallback){
    let self = this;
    BasePanel.prototype.ctor.call(self);
    self.onCloseCallback = onCloseCallback;
}

QQLiveSharePanel.prototype.initSharePanel =  function (){
    let self = this;
    
    let imageNode = null
    if (cc.spriteFrameCache.getSpriteFrame(PANEL_NAME)) {
        imageNode = cc.Sprite.createWithSpriteFrameName(PANEL_NAME)
    }else {
        imageNode = cc.Sprite.create()
        let iconName = getRealResourceName(PANEL_NAME)
        cc.loader.autoLoad(iconName, function () {
            let texture = cc.textureCache.addImage(PANEL_NAME)
            imageNode._renderCmd._setTexture(texture);
            imageNode.initWithFile(iconName)
        })
    }
    imageNode.setName("icon")
    self.addChild(imageNode)

    //let shareIcon = self.getChildByName("icon")
    imageNode.setAnchorPoint(1.0, 1.0)
    let ratio = display.height / GamePlayConfig_Design_Height
    imageNode.setPosition((GamePlayConfig_Design_Width*0.5-5)*ratio, (GamePlayConfig_Design_Height*0.5 - 10)*ratio)
}

QQLiveSharePanel.prototype.onClickAnywhere = function (){
    let self = this;
    BasePanel.prototype.onClose.call(self, self.onCloseCallback, null, true)
}

QQLiveSharePanel.prototype.onCleanup = function () {
    let self = this
    //ResManager.release(["cocos/prompt_share.plist"])
}

QQLiveSharePanel.prototype.popup = function (dark, canTouchBehind, callback) {
    var self = this
    self.isClosed = false
    PopoutManager.getInstance().addWithBgFadeIn(self, dark, canTouchBehind)  
    if (callback) {
        callback()
    }
    var vSize = cc.Director.getInstance().getVisibleSize()
    self.setPosition(vSize.width / 2, vSize.height / 2)
    return self
}

QQLiveSharePanel.prototype.closePanel = function(){
    let self = this
    self.onClickAnywhere()

}

//ResManager.load(["cocos/prompt_share.plist"]);
var _qqLiveSharePanel = QQLiveSharePanel.create()
QQLiveSharePanel.preload().then(
    function(){
        _qqLiveSharePanel.initSharePanel()
    }
)

module.exports = _qqLiveSharePanel;